<template>
<div class="chapter">
<div class="inner_page">
<div id="dedication">
<p class="center">To Nancy Deason Boeninghausen; my profile in courage.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004-dedication.vue?3a22f177